export const classOptions = [
    {
        text: "Samoan 101",
        value: 1,
        key: 0
    },
    {
        text: "Samoan 102",
        value: 2,
        key: 1
    }
]
